"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intToPix = exports.pixToInt = exports.sumStyle = void 0;
/**
 * Add int pixels to a css style (left or top generally)
 * @param  {string} style Style string in css format
 * @param  {number} diff The pixels to add/subtract
 * @returns {string} Style as string for css use
 */
function sumStyle(style, diff) {
    return intToPix(pixToInt(style) + diff);
}
exports.sumStyle = sumStyle;
/**
 * Converts a pixel string to an int
 * @param  {string} pix Pixel string
 * @return {number} Integer value of the pixel string
 */
function pixToInt(pix) {
    return parseInt(pix.replace('px', ''));
}
exports.pixToInt = pixToInt;
/**
 * Convert integer to pixel string.
 * If not an integer the input is returned as is
 * @param  {number} int Integer value
 * @returns {string} Pixel string
 */
function intToPix(int) {
    if (int === Number(int))
        return int + 'px';
    return int;
}
exports.intToPix = intToPix;
//# sourceMappingURL=commonUtils.js.map